import { render, staticRenderFns } from "./sharing-toggle.vue?vue&type=template&id=ea8bf778&"
import script from "./sharing-toggle.vue?vue&type=script&lang=js&"
export * from "./sharing-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports